export default __webpack_public_path__ + "static/TierFive-4e16b047550746955368cfeb3fc3d253.webp";